<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :search="query"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permission.departmentrentrecord_view"
          @click="openViewHistoryDialog(scope.row)"
          >历史租房
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      width="60%"
      title="历史租房"
      :visible.sync="openViewHistoryDialogFlag"
      v-if="openViewHistoryDialogFlag"
      :modal-append-to-body="false"
      append-to-body
      @close="quitViewHistoryDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form ref="viewHistoryFormRef" v-model="viewHistoryForm" :option="viewHistoryOption">
          <template slot="test" slot-scope="">
            <avue-crud :data="viewData" :option="viewOption">
              <template slot="menu" slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-view"
                  v-if="permission.departmentrentrecord_view"
                  @click="openFeePayView(scope.row)"
                  >缴费明细
                </el-button>
              </template>
            </avue-crud>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
    import {checkPath} from '@/api/user'
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getRentRecordHistory,
} from '@/api/v4ward/department/departmentrentrecord';
import { mapGetters } from 'vuex';
import viewHistoryOption from './departmentrentercrud-history-option';
import { setStore } from '@/util/store';
export default {
  data() {
    return {
      name: '', //租户名称
      form: {},
      viewHistoryForm: {},
      viewHistoryOption: viewHistoryOption,
      openViewHistoryDialogFlag: false,
      viewData: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 100,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        delBtn: false,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '租户名称',
            prop: 'name',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入租户名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系电话',
            prop: 'mobile',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'blur',
              },
              {
                trigger: 'blur',
                min: 11,
                max: 11,
                message: '请输入11位手机号码',
              },
            ],
          },
          {
            label: '性别',
            prop: 'sex',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=sex',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择性别',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '身份证',
            prop: 'idCard',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
                message: '请输入正确的身份证号码',
              },
              {
                required: true,
                message: '请输入身份证号码',
                trigger: 'blur',
              },
              {
                min: 18,
                max: 18,
                message: '请输入18位身份证号码',
              },
            ],
          },
          {
            label: '工作单位',
            width: 150,
            prop: 'companyName',
            search: true,
            type: 'tree',
            dicUrl: 'api/v4ward/departmentCompany/getDepartmentCompanyList',
            props: { label: 'companyName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择工作单位',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '修改人',
            prop: 'updateUserName',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
        ],
      },
      viewOption: {
        calcHeight: 50,
        height: '400',
        indexLabel: '序号',
        page: false,
        border: true,
        addBtn: false,
        selection: false,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        delBtn: false,
        editBtn: false,
        menuAlign: 'center',
        // menu: false,
        column: [
          {
            label: '房间名称',
            prop: 'propertyName',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '公寓床位',
            prop: 'bunkNum',
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '起租时间',
            prop: 'startDate',
          },
          {
            label: '退租时间',
            prop: 'endDate',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission', 'tagList']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentrentrecord_add, false),
        viewBtn: this.vaildData(this.permission.departmentrentrecord_view, false),
        delBtn: this.vaildData(this.permission.departmentrentrecord_delete, false),
        editBtn: this.vaildData(this.permission.departmentrentrecord_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    openFeePayView(row) {
      // this.removeTag();
      setStore({
        name: 'departmentUserInfo',
        content: row
      });
      this.$router.push({
        path: '/v4ward/department/departmentfeepay?fromPage='+(+new Date),
        meta:{
          $keepAlive:false
        }
      });
      this.openViewHistoryDialogFlag = false;
    },
    openViewHistoryDialog(row) {
      getRentRecordHistory({ renterId: row.id }).then(({ data }) => {
        this.viewData = data;
      });
      setStore({
        name: 'departmentUserName',
        content: row.name
      });
      this.viewHistoryForm = row;
      this.name = row.name;
      this.openViewHistoryDialogFlag = true;
    },
    quitViewHistoryDialog() {
      this.openViewHistoryDialogFlag = false;
      this.viewData = [];
      this.$refs.viewHistoryFormRef.resetForm();
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
